import { useCallback } from "react";
import { useCookies } from "react-cookie";

import { cookieConfig } from "../utils/storage/storage.constants";

const useCookiesWithOptions = (dependencies) => {
  const instance = useCookies(dependencies);
  const setFn = instance[1];

  const setFnWithOptions = useCallback((name, value, options = undefined) => {
    return setFn(name, value, options ? {
      ...cookieConfig,
      ...options,
    } : cookieConfig);
  }, [setFn]);

  return [instance[0], setFnWithOptions];
};

export default useCookiesWithOptions;
